import { render, staticRenderFns } from "./EndorsementPrintTemplate.vue?vue&type=template&id=691ff923&scoped=true"
import script from "./EndorsementPrintTemplate.vue?vue&type=script&lang=ts"
export * from "./EndorsementPrintTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691ff923",
  null
  
)

export default component.exports